// extracted by mini-css-extract-plugin
module.exports = {"btn":"Buttons_btn__CMxOa","btnOutline":"Buttons_btnOutline__1bqq-","btnFill":"Buttons_btnFill__38mAP","circle":"Buttons_circle__ekERE","sharp":"Buttons_sharp__Kd-Xo"};